module.exports = __webpack_public_path__ + "static/media/founder.5f003331.png";